import { render, staticRenderFns } from "./ModalMigrateConfirm.vue?vue&type=template&id=52fb515c&scoped=true&"
import script from "./ModalMigrateConfirm.vue?vue&type=script&lang=ts&"
export * from "./ModalMigrateConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./ModalMigrateConfirm.vue?vue&type=style&index=0&id=52fb515c&lang=scss&scoped=true&"
import style1 from "./ModalMigrateConfirm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fb515c",
  null
  
)

export default component.exports